export default __webpack_public_path__ + "static/media/Palletech 11.2.b80f3922.jpg";